import { mapHexHoverColor } from '@buggy/shared'
import { ConfigProvider } from 'antd'
import { FunctionComponent, ReactNode } from 'react'
import { useTheme } from 'styled-components'

interface PlanConfigProviderProps {
  children: ReactNode
  color?: string
}

const PlanConfigProvider: FunctionComponent<PlanConfigProviderProps> = ({
  children,
  color,
}) => {
  const theme = useTheme()
  const planColor = color ?? theme.colors.plan.advanced
  const planColorHover = mapHexHoverColor(planColor)

  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            colorPrimary: planColor,
            colorPrimaryHover: planColorHover,
            colorLink: planColor,
            colorLinkHover: planColorHover,
          },
          Input: {
            activeBorderColor: planColor,
            hoverBorderColor: planColorHover,
          },
        },
        token: {
          colorPrimary: planColor,
          colorPrimaryActive: planColor,
          colorPrimaryTextActive: planColor,
          colorLink: planColor,
          colorLinkActive: planColor,
          colorPrimaryHover: planColorHover,
          colorPrimaryTextHover: planColorHover,
          colorLinkHover: planColorHover,
        },
      }}
    >
      {children}
    </ConfigProvider>
  )
}

export default PlanConfigProvider
